import { useState, useEffect, useContext } from "react";
import "./DetailOrder.scss";
import Reserve from "../Reserve/Reserve";
import axios from "axios";
import { prefixUrl } from "../../../Utils/utilsData";
import ListOfDate from "../../ListOfDate/ListOfDate";
import { toast } from "react-toastify";
import { SetDiscountContext } from "../../pages/Pages";

const DetailOrder = ({ detailOrderData, onSelect, weight }) => {
	const mainContext = useContext(SetDiscountContext);
	const [payMethod, setPayMethod] = useState("");
	const [dateData, setDateData] = useState({});

	useEffect(() => {
		weight.length > 0
			? selectMethod("type", "2")
			: selectMethod("type", "1");

		if (mainContext.finalPrice === 0) {
			selectMethod("type", "3");
		}

		axios.get(`${prefixUrl()}/cart/deliveryTime.php`).then((response) => {
			if (response.data.status) {
				setDateData(response.data.output);
			} else {
				toast.error("خطا در بر قراری ارتباط");
			}
		});
	}, []);

	const selectMethod = (name, value) => {
		onSelect(name, value);
		name === "type" && setPayMethod(value);
	};

	return (
		<div className="main-detail-order">
			<div className="row-order">
				{detailOrderData?.detail?.map((v, index) => (
					<div className="order-box" key={"O" + index}>
						<div className="image-top">
							<img src={v?.images[0]?.url} alt="" />
						</div>
						<p>{v?.productName}</p>
					</div>
				))}
			</div>

			<div className="sending-section">
				<div className="title-basket" style={{ width: "100%" }}>
					<h4>
						{weight.length === 0
							? "انتخاب شیوه پرداخت"
							: "شیوه پرداخت"}
					</h4>
					<div className="yellow-line"></div>
				</div>
				<div className="row-order">
					{mainContext.finalPrice !== 0 && (
						<div
							className={
								payMethod === "2"
									? "sending-method active-method"
									: "sending-method"
							}
							onClick={() => selectMethod("type", "2")}
						>
							پرداخت در محل
						</div>
					)}

					{weight.length === 0 && mainContext.finalPrice !== 0 && (
						<div
							className={
								payMethod === "1"
									? "sending-method active-method"
									: "sending-method"
							}
							onClick={() => selectMethod("type", "1")}
						>
							پرداخت آنلاین
						</div>
					)}

					{/* digital wallet payment method */}
					<div
						className={
							payMethod === "3"
								? "sending-method active-method"
								: "sending-method"
						}
						onClick={() => selectMethod("type", "3")}
					>
						پرداخت با کیف پول
					</div>
				</div>
			</div>

			<div className="sending-section">
				<div className="title-basket" style={{ width: "100%" }}>
					<h4>انتخاب روز و زمان</h4>
					<div className="yellow-line"></div>
				</div>

				<div className="sending-date">
					{Object.keys(dateData).length > 0 ? (
						<ListOfDate dateData={dateData} onSelect={onSelect} />
					) : (
						""
					)}
				</div>
			</div>
		</div>
	);
};
export default DetailOrder;
